export const COOKIE_ACCEPTED_KEY = 'cookie_accepted';
export const COOKIE_ACCEPTED_VALUE = '1';



// WEBPACK FOOTER //
// ./src/services/header/cookiebanner/constants.js